import ElementContentRelatedProduct from '@/components/sections/builder/elements/body/related-product/content';
import ElementSettingRelatedProduct from '@/components/sections/builder/elements/body/related-product/setting';
import { RelatedProductElementDataType } from '@/components/sections/builder/elements/body/related-product/type';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: RelatedProductElementDataType = {
  name: 'Related Product',
  contentAlign: 'left',
  headingLabel: 'Related Products',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  limit: 4,
  totalCol: 4,
  totalColMobile: 1,
  size: 'small',
  showImage: true,
  showCategory: true,
  showShadow: false,
  rounded: 0,
  imageRatio: 'square',
  viewAllStyle: 'default',
  labelViewAll: 'View all',
  positionViewAll: 'bottom',
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const RelatedProduct = {
  type: 'related_product',
  group: 'body_product_detail',
  defaultData,
  Element: ElementContentRelatedProduct,
  Setting: ElementSettingRelatedProduct,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
  maxEntries: 1,
};

export default RelatedProduct;
